import { Model } from 'app/model/backendmodel';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { MicrosoftAccessCopySource } from 'app/model/pipeline/copysource/microsoft-access.copysource';
import { ValueAdapter } from '../../value.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MicrosoftAccessCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class MicrosoftAccessCopySourceAdapter extends CopySourceAdapter<
    MicrosoftAccessCopySource,
    Model.MicrosoftAccessSource
> {
    protected override async _toResource(copySource: MicrosoftAccessCopySource): Promise<Model.MicrosoftAccessSource> {
        const result: Model.MicrosoftAccessSource = this.getCommonCopySourceProperties(
            copySource,
            Metamodel.modelFor(MicrosoftAccessCopySource).name
        );
        if (copySource.mode === 'query') {
            result.query = ValueAdapter.toResource(copySource, MicrosoftAccessCopySource.READER_QUERY);
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.MicrosoftAccessSource,
        copyActivity: CopyActivity
    ): Promise<MicrosoftAccessCopySource> {
        return this._toTabularModel(resource, copyActivity, MicrosoftAccessCopySource.MODEL);
    }
}
